module.exports = __webpack_public_path__ + "3e059cf5a091431ebb46fdde43da4c24.svg";